<div>
  {{registro.objeto.cultivar}}
  <br/>
  Quantidade de Plantas: {{registro.objeto.number_of_lines}}
  <br/>
  PMS: {{registro.objeto.pms}}
  <br/>
  Densidade de Plantas Estabelecidas: {{registro.objeto.density | number}} pl/ha
  <br/>
  Média de Grãos por Planta: {{registro.objeto.grains | number}}
  <br/>
  Produtividade Estimada: {{registro.objeto.fertility | number}} sc/ha
  {{registro.objeto.observacoes ? '<br/>' + registro.objeto.observacoes : ''}}
</div>